export const APP_TITLE = 'Data Upload Tool';
export const BACK_TEXT = 'back';
export const NEXT_TEXT = 'next';
export const CANCEL_TEXT = 'cancel';
export const FINISH_TEXT = 'send';
export const STEP_TEXT = 'Step';
export const OF_TEXT = 'of';
export const DRAG_DROP = 'Drag & Drop Files';
export const SELECT_FILE = 'Choose a File';
export const ADD_USER_TEXT = 'Add user';
export const DELETE_USER_TEXT = 'Delete user';

export const SELECT_TYPE_STEP_NAME = 'type';
export const SELECT_OBJECTS_STEP_NAME = 'objects';
export const UPLOAD_FILE_STEP_NAME = 'file';
export const UPLOAD_STREAM_STEP_NAME = 'stream';
export const MAPPING_STEP_NAME = 'mapping';
export const METADATA_STEP_NAME = 'metadata';
export const FINISHED_STEP_NAME = 'finished';

export const SELECT_TYPE_STEP_TEXT = 'Select Type of Data';
export const SELECT_OBJECTS_STEP_TEXT = 'Select Kind of Objects Containing';
export const UPLOAD_FILE_STEP_TEXT = 'Upload Data';
export const UPLOAD_STREAM_STEP_TEXT = 'Set Stream Endpoint';
export const MAPPING_STEP_TEXT = 'Map the Fields';
export const METADATA_STEP_TEXT = 'Add Metadata';
export const FINISHED_STEP_TEXT = 'Finished';

export const SELECT_TYPE_TITLE = 'What would you like to import?';
export const SELECT_OBJECTS_TITLE = 'What kind of objects do you like to import?';
export const UPLOAD_FILE_TITLE = 'Upload your file';
export const UPLOAD_STREAM_TITLE = 'Set your stream endpoint';
export const MAPPING_TITLE = 'Map columns in your file to object properties';
export const METADATA_TITLE = 'Add some final useful information';
export const FINISHED_TITLE = 'Congratulations! Your data have been added successfully to the Data Platform!';

export const SELECT_TYPE_SUBTITLE = 'Starting, please choose the type of data you want to upload. Is it a data file or a stream like a sensor API?';
export const SELECT_OBJECTS_SUBTITLE = 'In Agroknow, objects are data types used to organize your info. Common objects are incidents, companies, prices and more.';
export const UPLOAD_FILE_SUBTITLE = 'Before you upload your file, please make sure it is ready to be imported.';
export const UPLOAD_STREAM_SUBTITLE = 'Please make sure to enter a valid url to the field bellow.';
export const MAPPING_SUBTITLE =
    "Each column header below should be mapped to a property in our Data Platform. Some of these may have already been mapped based on their names. Anything that hasn't been mapped yet can be manually mapped to a property with the dropdown menu.";
export const METADATA_SUBTITLE = 'Adding some final information about your dataset, will help us manage it better.';
export const FINISHED_SUBTITLE = 'Thank you for using the Data Upload Tool!';

export const SELECT_TYPE_INFOBOX = 'Need help getting started? View import guide';
export const SELECT_OBJECTS_INFOBOX = null;
export const UPLOAD_FILE_INFOBOX = 'If the file contains tabular data, the first row must have unique headers to distinguish the different columns.';
export const UPLOAD_STREAM_INFOBOX = null;
export const MAPPING_INFOBOX = 'What does this mean?';
export const METADATA_INFOBOX = null;
export const FINISHED_INFOBOX = null;
